import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import _DetailsForm from "DetailsForm.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/details_form.js?styleId=DetailsForm";


const DetailsForm = /*#__PURE__*/styled('div', null, {
  displayName: "DetailsForm",
  styles: _DetailsForm,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export default DetailsForm
